import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
    baseURL: `${API_URL}/api`,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Handle auth errors
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

// Auth API
export const authAPI = {
    register: (data) => api.post('/auth/register', data),
    login: (data) => api.post('/auth/login', data),
    getMe: () => api.get('/auth/me'),
};

// Game API
export const gameAPI = {
    startGame: (mode, subject) => api.post(`/game/start?mode=${mode}${subject ? `&subject=${encodeURIComponent(subject)}` : ''}`),
    submitAnswer: (sessionId, data) => api.post(`/game/${sessionId}/answer`, data),
    endGame: (sessionId) => api.post(`/game/${sessionId}/end`),
};

// Demo API (no auth required)
export const demoAPI = {
    startDemo: () => api.post('/demo/start'),
    submitAnswer: (sessionId, data) => api.post(`/demo/${sessionId}/answer`, data),
    endDemo: (sessionId) => api.post(`/demo/${sessionId}/end`),
};

// Questions API
export const questionsAPI = {
    getSubjects: () => api.get('/questions/subjects'),
    getQuestions: (params) => api.get('/questions', { params }),
    getRandomQuestions: (params) => api.get('/questions/random', { params }),
};

// Leaderboard API
export const leaderboardAPI = {
    getLeaderboard: (limit = 100) => api.get(`/leaderboard?limit=${limit}`),
    getMyRank: () => api.get('/leaderboard/me'),
};

// Stats API
export const statsAPI = {
    getMyStats: () => api.get('/stats/me'),
    getAchievements: () => api.get('/achievements'),
};

// Flashcards API
export const flashcardsAPI = {
    getFlashcards: (params) => api.get('/flashcards', { params }),
};

// Admin API
export const adminAPI = {
    seedQuestions: () => api.post('/admin/seed-questions'),
    generateQuestions: (subject, count) => api.post(`/admin/generate-questions?subject=${encodeURIComponent(subject)}&count=${count}`),
    getQuestions: (params) => api.get('/admin/questions', { params }),
    updateQuestion: (id, data) => api.put(`/admin/questions/${id}`, data),
    deleteQuestion: (id) => api.delete(`/admin/questions/${id}`),
    getUsers: () => api.get('/admin/users'),
    toggleAdmin: (id) => api.put(`/admin/users/${id}/toggle-admin`),
    getStats: () => api.get('/admin/stats'),
};

export default api;
